<template>
  <div class="article">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增文章
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋標題、分類"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(category)="data">
              {{ data.item.category.name }}
            </template>
            <template v-slot:cell(publish_at)="data">
              {{ new Date(data.item.publish_at).format('yyyy-MM-dd hh:mm') }}
            </template>
            <template v-slot:cell(updated_at)="data">
              {{ new Date(data.item.updated_at).format('yyyy-MM-dd hh:mm') }}
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <div class="form-check check-icon">
                  <input
                    v-model="data.item.status"
                    class="form-check-input"
                    type="checkbox"
                    :id="'status' + data.item.id"
                    @click="toggleStatus(data.item.id)"
                  />
                  <label
                    class="form-check-label"
                    :class="{ 'text-primary': data.item.status }"
                    :for="'status' + data.item.id"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="data.item.status ? '隱藏' : '顯示'"
                  >
                    <i
                      class="bi"
                      :class="
                        data.item.status ? ' bi-eye-fill' : 'bi-eye-slash-fill'
                      "
                    ></i>
                  </label>
                </div>
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil fs-5"></i>
                </button>
                <button
                  @click="showDeleteModal(data.item.id, data.item.title)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="刪除"
                >
                  <i class="bi bi-trash fs-5"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="articleModal"
      tabindex="-1"
      ref="articleModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-fullscreen-lg-down modal-dialog-scrollable"
      >
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEdit ? '編輯文章：' + modalDate.title : '新增文章' }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="`modalStatic_uri`" class="form-label required"
                      >上架狀態</label
                    >
                    <div class="d-flex mb-3">
                      <div class="form-check me-3">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="modalDate.status"
                          id="modalStatusTrue"
                          name="modalDateStatus"
                          :value="1"
                        />
                        <label class="form-check-label" for="modalStatusTrue">
                          顯示
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="modalDate.status"
                          id="modalStatusFalse"
                          name="modalDateStatus"
                          :value="0"
                        />
                        <label class="form-check-label" for="modalStatusFalse">
                          隱藏
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="modalPublish_at" class="form-label required"
                      >上架時間</label
                    >
                    <input
                      v-model="modalDate.publish_at"
                      type="datetime-local"
                      class="form-control"
                      id="modalPublish_at"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="`modalStatic_uri`" class="form-label required"
                      >自定網址</label
                    >
                    <input
                      v-model="modalDate.static_uri"
                      type="text"
                      class="form-control"
                      id="modalStatic_uri"
                      required
                      placeholder="請輸入"
                      pattern="[0-9a-z\-_]+"
                    />
                    <div class="form-text">
                      只能用英文小寫、數字及'-'、'_'符號(非字首)，不可有空白
                      <br />
                      用於強化 SEO 搜尋
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="modalTitle" class="form-label required"
                      >標題</label
                    >
                    <input
                      v-model="modalDate.title"
                      type="text"
                      class="form-control"
                      id="modalTitle"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label required">文章分類</label>
                    <select
                      v-model="modalDate.category_id"
                      class="form-select"
                      required
                    >
                      <option :value="null">請選擇文章分類</option>
                      <option
                        v-for="category in articleCategory"
                        :value="category.id"
                        :key="'articleCategory' + category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <h6 class="form-label">封面圖片</h6>
                    <div class="float-end">
                      <div class="imgBox-has-close">
                        <button
                          v-if="modalDate.cover_image"
                          @click="removeImage"
                          type="button"
                          class="btn-close"
                          aria-label="Close"
                        />
                        <div class="imgBox ms-2" style="width: 120px">
                          <div class="imgBox-inner">
                            <div class="imgBox-fit">
                              <img
                                v-if="modalDate.cover_image"
                                :src="modalDate.cover_image"
                                alt=""
                              />
                              <i v-else class="bi bi-image"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-html="imageSizeNote" class="form-text mb-3" />
                    <div class="mb-3">
                      <label
                        for="formFileCoverImage"
                        class="btn btn-outline-primary"
                        ><i class="bi bi-image"></i> 上傳圖片</label
                      >
                      <input
                        class="form-control d-none"
                        type="file"
                        id="formFileCoverImage"
                        accept="image/png, image/jpeg"
                        @change="onFileChange()"
                        ref="formFileCoverImage"
                      />
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="websiteKeyword" class="form-label"
                      >關鍵字</label
                    >
                    <div class="form-text mb-3">
                      用於 SEO Keyword ，最多添加 5 項。
                    </div>
                    <div>
                      <button
                        type="button"
                        @click="modalDate.seo_keyword.splice(index, 1)"
                        class="btn btn-primary rounded-pill me-2 mb-2 pe-3"
                        v-for="(keywords, index) in modalDate.seo_keyword"
                        :key="keywords + index"
                      >
                        {{ keywords }} <i class="bi bi-x ps-2"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      @click="showKeywordsModal"
                      v-show="
                        modalDate.seo_keyword &&
                        modalDate.seo_keyword.length < 5
                      "
                      class="btn btn-outline-primary mt-2"
                    >
                      <i class="bi bi-plus"></i> 新增關鍵字...
                    </button>
                  </div>
                  <div class="mb-3">
                    <label for="websiteDescription" class="form-label"
                      >文章簡介</label
                    >
                    <textarea
                      v-model="modalDate.description"
                      class="form-control"
                      id="websiteDescription"
                      rows="3"
                      placeholder="請輸入"
                    ></textarea>
                    <div class="form-text">
                      {{
                        modalDate.description ? modalDate.description.length : 0
                      }}
                      / 160
                    </div>
                    <div class="form-text">
                      用於 SEO Description，建議中文字數控制在 80
                      字以內，英文字數控制在 160 字以內。
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-3">
                <label class="form-label">文章內容</label>
                <quill v-model="modalDate.content" />
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <KeywordsModal
      @setKeywords="addKeywords"
      :keywords="modalDate.seo_keyword"
    />
    <DeleteModal
      name="文章"
      :deleteItem="deleteItem"
      @confirmDelete="deleteArticle"
    />
  </div>
</template>

<script>
import { article } from '@/http/api/article.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import quill from '@/components/plugin/Quill.vue'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'
import KeywordsModal from '@/components/modal/KeywordsModal.vue'

const defaultModalDate = {
  category_id: null,
  content: null,
  cover_image: null,
  description: null,
  publish_at: new Date().format('yyyy-MM-ddThh:mm'),
  seo_keyword: [],
  static_uri: null,
  status: 1,
  title: null
}

export default {
  name: 'Article',
  components: {
    quill,
    Title,
    Breadcrumb,
    DeleteModal,
    KeywordsModal
  },
  data () {
    return {
      articleCategory: null,
      bootstrap_modal: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        category_id: '文章分類',
        content: '文章內容',
        cover_image: '封面圖片',
        description: '文章簡介',
        publish_at: '上架時間',
        seo_keyword: '關鍵字',
        static_uri: '自定網址',
        status: '上架狀態',
        title: '標題'
      },
      fields: [
        {
          key: 'title',
          label: '標題',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'category',
          label: '分類',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'publish_at',
          label: '上架時間',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'updated_at',
          label: '更新時間',
          class: 'align-middle',
          sortable: true
        },
        { key: 'active', label: '功能', class: 'align-middle' }
      ],
      filter: null,
      filterOn: ['title', 'category'],
      isEdit: false,
      items: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate)),
      modalID: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows',
      'isShowKeywordsModal'
    ]),
    ...mapGetters(['errMsgInfo', 'clientName']),
    imageSizeNote () {
      let note = ''
      switch (this.clientName) {
        default:
          note = `圖片尺寸建議: <br />
                  500 x 400 px <br />
                  (圖片格式：JPG、PNG) <br />
                  檔案大小建議：在保持解析度的條件下容量越小越好，會影響seo分數
                  <br />
                  <a href="https://tinypng.com/" target="_blank">(免費壓縮網址)</a>`
          break
      }
      return note
    }
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    isShowKeywordsModal (data) {
      if (!data) this.bootstrap_modal.show()
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal',
      'ToggleKeywordsModal'
    ]),
    ...mapActions(['uploadImage']),
    addKeywords (data) {
      const vm = this
      vm.modalDate.seo_keyword = data
    },
    createArticle () {
      const vm = this
      article
        .create(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getAllArticles()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteArticle () {
      const vm = this
      article
        .delete(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.ToggleDeleteModal(false)
            vm.getAllArticles()
          } else {
            vm.ToggleDeleteModal(false)
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
    },
    getAnArticle (id) {
      const vm = this
      return new Promise((resolve) => {
        article
          .get(id, vm.token)
          .then((res) => {
            const { data } = res
            if (res.status <= 201 && data.status === 'success') {
              const articleDate = data.data
              resolve(articleDate)
            } else {
              vm.SetErrMsg(data.errMsg)
              vm.AlertsInfo({
                state: 'error',
                title: '失敗 ' + res.status,
                info: vm.errMsgInfo
              })
              vm.Alerted()
            }
            vm.Loaded()
          })
          .catch((err) => {
            vm.SetErrMsg(err)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗',
              info: vm.errMsgInfo
            })
            vm.Alerted()
            vm.Loaded()
          })
      })
    },
    getAllArticles () {
      const vm = this
      vm.Loading()
      article
        .get('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getArticleCategory () {
      const vm = this
      vm.Loading()
      article
        .getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.articleCategory = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    initialEvent () {
      const vm = this
      vm.getAllArticles()
      vm.getArticleCategory()
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    onFileChange () {
      const vm = this
      vm.uploadImage(vm.$refs.formFileCoverImage)
        .then((value) => {
          if (value) {
            vm.modalDate.cover_image = value
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    removeImage () {
      this.modalDate.cover_image = null
    },
    async showModal (id) {
      const vm = this
      vm.modalID = id
      vm.bootstrap_modal = new Modal(vm.$refs.articleModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.isEdit = false

      if (!id) {
        vm.modalDate = JSON.parse(JSON.stringify(defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()

      const articleDate = await vm.getAnArticle(id)

      vm.modalDate = articleDate
      vm.modalDate.publish_at = new Date(vm.modalDate.publish_at).format(
        'yyyy-MM-ddThh:mm'
      )
      vm.bootstrap_modal.show()
      vm.Loaded()
    },

    showKeywordsModal () {
      const vm = this
      vm.ToggleKeywordsModal(true)
      vm.bootstrap_modal.hide()
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      vm.Loading()
      if (vm.isEdit) {
        vm.updateArticle()
        return
      }
      vm.createArticle()
    },
    async toggleStatus (id) {
      const vm = this
      vm.Loading()
      const articleDate = await vm.getAnArticle(id)
      articleDate.status = articleDate.status ? 0 : 1
      article
        .update(id, articleDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '變更顯示狀態成功'
            })
            vm.getAllArticles()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    updateArticle () {
      const vm = this
      article
        .update(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getAllArticles()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
